import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { CTA } from "@/types";

export enum PageLocation {
  DEFAULT = "default",
  BOTTOM = "bottom",
}

export type CTAProps = {
  title: string;
  subtitle?: string;
  titleSize?: "default" | "small" | "large";
  emphasizeTitle?: boolean;
  cta?: CTA | null;
  theme?:
    | "default"
    | "light"
    | "gray"
    | "dark"
    | "tones"
    | "light-dark"
    | "transparent"
    | "dark-gradient";
  background_image?: string | StaticImport;
  brandimage?: string;
  border?: "top" | "bottom" | "both" | "full";
  children?: React.ReactNode;
  imagealttext?: string;
  fullsize?: boolean;
  children_container_classname?: string;
  locationRestrictions?: {
    allowedIn: string[];
    blockedIn: string[];
  };
  pageLocation?: PageLocation;
};

export type Variants =
  | "banner"
  | "register"
  | "split"
  | "image-right"
  | "multi-course"
  | "image-left"
  | "dynamic-product-list"
  | "copy-right-plus-button"
  | "image-right-about-us"
  | "banner-product-upsell";

export type CTAComponentProps = CTAProps & {
  variant: Variants;
  pagetype?: string;
};
